<template>
  <v-container fluid>
    <ReservationsTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="
            $t('actions.export', {
              entity: $tc('Reservation').toLowerCase()
            })
          "
        />
        <avs-createButton
          @click="handleNewReservation"
          :spantext="$tc('Creer une reservation', 1).toLowerCase()"
          :name="$tc('Nouvelle reservation', 1).toLowerCase()"
        />
      </template>
    </ReservationsTable>
  </v-container>
</template>
<script>
import ReservationsTable from "@/components/ri3/reservation/ReservationsTable.vue"
import { fmtInspectionData } from "@/utils/download"

export default {
  name: "ReservationsView",
  components: { ReservationsTable },
  computed: {
    project() {
      return this.$store.state.app.project
    }
  },
  data() {
    return {
      loading: false,
      newMenuItems: [
        {
          text: this.$t("categories.inspection.plan"),
          icon: "mdi-calendar-cursor",
          function: this.handleNewReservation
        }
      ]
    }
  },
  methods: {
    handleNewReservation() {
      this.$router.push({
        name: "ReservationCreateUpdate"
      })
    },
    preFmtData(dataset) {
      return fmtInspectionData(dataset)
    }
  }
}
</script>
